
export const fontWeights = {
    thin:100,
    light:300,
    regular:400,
    medium:500,
    bold:700,
}
